import { Icon } from '../Icon'
import Button from '../app/design/Button'

type Props = {
    label: string
    active?: boolean
    open?: boolean
    disabled?: boolean
    onClick: () => void
}

export const CalendarFilterPillButton = ({
    label,
    active = false,
    open = false,
    disabled = false,
    onClick,
}: Props) => {
    return (
        <Button shape="pill" size="small" active={active} disabled={disabled} onClick={onClick}>
            {label.slice(0, 12)}
            {label.length > 12 ? '...' : ''}
            {!disabled && (
                <Icon
                    icon="chevronDown.small"
                    className={`transform transition-transform duration-200 ease-in-out ${
                        open ? 'rotate-180' : 'rotate-0'
                    }`}
                />
            )}
            {disabled && <Icon icon="chevronDown.small" />}
        </Button>
    )
}
